function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as i } from "./index.es33.js";
import { clsx as x } from "./index.es105.js";
import { Typography as a } from "./index.es35.js";
import "./index.es36.js";
import { Tooltip as m } from "./index.es13.js";
import { TooltipShorten as j } from "./index.es14.js";
import "./index.es15.js";
import { Link as h } from "./index.es42.js";
import s from "./index.es203.js";

var P = function P(_ref) {
  var r = _ref.label,
      l = _ref.tooltipAlternativePosition,
      c = _ref.withRequiredSign,
      e = _ref.optionalText,
      o = _ref.tooltipInfoText,
      t = _ref.infoText,
      n = _ref.link,
      d = _ref.isDisabled,
      p = _ref.color;
  return i.jsxs(a.Body2, {
    as: "div",
    className: x(s.container, _defineProperty({}, s.isDisabled, d)),
    color: p,
    children: [i.jsx(j, {
      title: r,
      children: r
    }), c && i.jsx("div", {
      className: s.requiredAsterisk,
      children: "*"
    }), e && i.jsx("div", {
      className: s.optionalText,
      children: e
    }), o && i.jsx("div", {
      className: s.tooltipContainer,
      children: i.jsx(m.Icon, {
        title: o,
        position: m.PositionVariants.underCenter,
        alternativePosition: l
      })
    }), i.jsxs("div", {
      className: s.rightSide,
      children: [t && i.jsx(a.Overline, {
        className: s.infoText,
        children: t
      }), n && i.jsx("div", {
        className: s.linkContainer,
        children: i.jsx(h, _objectSpread({}, n))
      })]
    })]
  });
};

export { P as Label };